import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { CollectionIcon } from '../icons/CollectionIcon';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';

export const CollectionsNavButton = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const isActive = location.pathname === '/collections';
  const navigate = useNavigate();

  return (
    <NavbarIconButtonWithLabel
      active={isActive}
      label={t('Collection Viewer')}
      onClick={() => {
        if (!isActive) {
          navigate('/collections');
        }
      }}
    >
      <CollectionIcon />
    </NavbarIconButtonWithLabel>
  );
};
